module.exports = __webpack_public_path__ + "static/media/error-icon.232e6fcd.svg";